export default __webpack_public_path__ + "static/media/bd-booking.671f6714.jpg";